<div class="max-w-5xl mx-auto bg-white my-16 box-shadow-ff rounded-sm p-8 text-sm text-gray-800">

  <!-- Header -->
  <div class="text-center">
    <div class="w-full flex justify-center"><a routerLink="/"><img src="assets/img/logo.png" alt="Logo" class="w-32 mb-4" /></a></div>
    <h1 class="text-xl font-semibold">{{ invoice.company.name }}</h1>
    <p class="text-xs mt-1">{{ invoice.company.address }}</p>
    <p class="text-xs mt-1">
      PAN: {{ invoice.company.pan }} | GST: {{ invoice.company.gst }}
    </p>
  </div>

  <!-- Title -->
  <div class="text-center mt-6">
    <h2 class="text-lg font-bold underline">Tax Invoice</h2>
  </div>

  <!-- Invoice Meta -->
  <div class="grid grid-cols-2 gap-4 mt-6 text-xs">
    <div>
      <p><strong>Invoice No:</strong> {{ invoice.invoiceNo }}</p>
      <p><strong>Invoice Date:</strong> {{ invoice.date || '—' }}</p>
      <p><strong>Reverse Charge:</strong> {{ invoice.reverseCharge }}</p>
      <p><strong>State:</strong> {{ invoice.state }} ({{ invoice.stateCode }})</p>
    </div>
    <div class="text-right">
      <p><strong>Place:</strong> {{ invoice.place }}</p>
    </div>
  </div>

  <!-- Bill To -->
  <div class="mt-6">
    <h3 class="font-semibold mb-1">Bill To</h3>
    <p>{{ invoice.billTo.name || '—' }}</p>
    <p class="text-xs">{{ invoice.billTo.contact || '—' }}</p>
  </div>

  <!-- Table -->
  <div class="mt-6">
    <table class="w-full border border-gray-300 text-xs">
      <thead class="bg-gray-100">
        <tr>
          <th class="border p-2">S.No</th>
          <th class="border p-2 text-left">Service Description</th>
          <th class="border p-2">SAC</th>
          <th class="border p-2">Qty</th>
          <th class="border p-2">Rate</th>
          <th class="border p-2">Amount</th>
          <th class="border p-2">Discount</th>
          <th class="border p-2">Taxable</th>
          <th class="border p-2">CGST</th>
          <th class="border p-2">SGST</th>
          <th class="border p-2">Total</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let item of invoice.items; let i = index">
          <td class="border p-2 text-center">{{ i + 1 }}</td>
          <td class="border p-2">{{ item.description }}</td>
          <td class="border p-2 text-center">{{ item.sac }}</td>
          <td class="border p-2 text-center">{{ item.qty }}</td>
          <td class="border p-2 text-right">{{ item.rate }}</td>
          <td class="border p-2 text-right">{{ item.amount }}</td>
          <td class="border p-2 text-right">{{ item.discount }}</td>
          <td class="border p-2 text-right">{{ item.taxable }}</td>
          <td class="border p-2 text-right">
            {{ item.cgstRate }}% ({{ item.cgstAmount }})
          </td>
          <td class="border p-2 text-right">
            {{ item.sgstRate }}% ({{ item.sgstAmount }})
          </td>
          <td class="border p-2 text-right font-semibold">{{ item.total }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Totals -->
  <div class="grid grid-cols-2 mt-6 gap-4">
    <div>
      <p class="text-xs">
        <strong>Total in words:</strong><br />
        Rupees Three thousand five hundred forty only.
      </p>
    </div>

    <div class="text-xs space-y-1">
      <div class="flex justify-between">
        <span>Total before Tax</span>
        <span>{{ invoice.totals.beforeTax }}</span>
      </div>
      <div class="flex justify-between">
        <span>Added: CGST</span>
        <span>{{ invoice.totals.cgst }}</span>
      </div>
      <div class="flex justify-between">
        <span>Added: SGST</span>
        <span>{{ invoice.totals.sgst }}</span>
      </div>
      <div class="flex justify-between">
        <span>Total Tax</span>
        <span>{{ invoice.totals.totalTax }}</span>
      </div>
      <div class="flex justify-between font-semibold border-t pt-2">
        <span>Total Amount</span>
        <span>{{ invoice.totals.afterTax }}</span>
      </div>
    </div>
  </div>

  <!-- Footer -->
  <div class="mt-10 text-xs">
    <p>
      Certified that the particulars given above are true and correct
    </p>

    <div class="flex justify-between mt-10">
      <div>
        <p>Common Seal</p>
        <img src="assets/img/seal.png" alt="Seal" class="w-36 mb-4" />
      </div>
      <div class="text-right">
        <p>For Company Name</p>
        <img src="assets/img/sign.png" alt="Signature" class="w-36 mt-4" />
        <p class="mt-4">Authorised Signatory</p>
      </div>
    </div>
  </div>

</div>